/**
 * The Replace / Keep existing question on a duplicate name (#151): the Files
 * module (upload, Nextcloud add) and the Reader's "Add document to
 * collection" ask it the same way.
 */

import type { ConfirmDialogOptions } from './confirm-dialog';
import type { TranslationParams } from '../i18n/ui-manager.types';

export function replaceQuestion(
  t: (key: string, params?: TranslationParams) => string,
  name: string
): ConfirmDialogOptions {
  return {
    title: t('modules.files.replaceTitle'),
    message: t('modules.files.confirmReplace', { name }),
    confirmLabel: t('modules.files.replace'),
    cancelLabel: t('modules.files.keepExisting'),
    danger: false,
  };
}
